import React from "react";

function Div3() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="313"
      height="143"
      fill="none"
      viewBox="0 0 313 143"
    >
      <g filter="url(#filter0_d_255_1042)">
        <path
          stroke="#61FF00"
          strokeWidth="0.644"
          d="M302 111.807l-30.227 20.198H170.68M11 35.785L35.853 10.97h103.781"
        ></path>
      </g>
      <defs>
        <filter
          id="filter0_d_255_1042"
          width="312.008"
          height="142.281"
          x="0.472"
          y="0.347"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset></feOffset>
          <feGaussianBlur stdDeviation="5.15"></feGaussianBlur>
          <feComposite in2="hardAlpha" operator="out"></feComposite>
          <feColorMatrix values="0 0 0 0 0.38 0 0 0 0 1 0 0 0 0 0 0 0 0 1 0"></feColorMatrix>
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_255_1042"
          ></feBlend>
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_255_1042"
            result="shape"
          ></feBlend>
        </filter>
      </defs>
    </svg>
  );
}

export default Div3;
